var poll_header_default = {
  "title": "cs55z",
  "image": "g1kO9",
  "webview": "aJuT2"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
